import { render, staticRenderFns } from "./AdminDonations.vue?vue&type=template&id=6ddb2e85&scoped=true"
import script from "./AdminDonations.vue?vue&type=script&lang=js"
export * from "./AdminDonations.vue?vue&type=script&lang=js"
import style0 from "./AdminDonations.vue?vue&type=style&index=0&id=6ddb2e85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb2e85",
  null
  
)

export default component.exports